import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import BarChartIcon from '@mui/icons-material/BarChart';
import AttachmentIcon from '@mui/icons-material/Attachment';
import PersonIcon from '@mui/icons-material/Person';
import { PqrListActionsProps } from './props';
import { PQR_EDIT, PQR_SURVEY_DETAIL } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';
import { usePqrAttachments } from '../../attachmentModal/hook';
import { usePqrStatusHistory } from '../../statusHistoryModal/hook';
import { AttachmentModal } from '../../attachmentModal';
import { StatusHistoryModal } from '../../statusHistoryModal';

export const PqrListActions = ({ id, isSurvey }: PqrListActionsProps) => {
    const {
        handleOnChange,
        formik,
        openAttachmentsModal,
        setOpenAttachmentsModal,
        handleCloseAttachmentsModal,
        handleSubmit,
        loading,
        columns,
        attachments,
    } = usePqrAttachments({ id: id as string });

    const {
        openStatusHistoryModal,
        setOpenStatusHistoryModal,
        handleCloseStatusHistoryModal,
        columnsStatusHistory,
        total,
        rows,
    } = usePqrStatusHistory({ id: id as string });

    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PQR_EDIT}/${id}/#CHANGE_STATUS`, '_blank');
    };

    const handleSurvey: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PQR_SURVEY_DETAIL}/${id}`, '_blank');
    };

    const handleOpenHistoryStatusModal:
        | MouseEventHandler<HTMLButtonElement>
        | undefined = (e) => {
            e.stopPropagation();
            setOpenStatusHistoryModal(true);
        };

    const handleOpenAttachmentsModal:
        | MouseEventHandler<HTMLButtonElement>
        | undefined = (e) => {
            e.stopPropagation();
            setOpenAttachmentsModal(true);
        };

    return (
        <>
            <Grid textAlign="left" width="100%">
                <Tooltip title="Editar">
                    <IconButton size="small" onClick={handleEdit}>
                        <EditIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    </IconButton>
                </Tooltip>
                {isSurvey && (
                    <Tooltip title="Encuesta">
                        <IconButton size="small" onClick={handleSurvey}>
                            <BarChartIcon
                                type="submit"
                                sx={{ color: 'primary.main' }}
                            />
                        </IconButton>
                    </Tooltip>
                )}
                <Tooltip title="Anexos">
                    <IconButton
                        size="small"
                        onClick={handleOpenAttachmentsModal}
                    >
                        <AttachmentIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Ver histórico estados">
                    <IconButton
                        size="small"
                        onClick={handleOpenHistoryStatusModal}
                    >
                        <PersonIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    </IconButton>
                </Tooltip>
            </Grid>
            <AttachmentModal
                formik={formik}
                handleOnChange={handleOnChange}
                openAttachmentsModal={openAttachmentsModal}
                handleCloseAttachmentsModal={handleCloseAttachmentsModal}
                handleSubmit={handleSubmit}
                loading={loading}
                columns={columns}
                attachments={attachments}
            />
            <StatusHistoryModal
                openStatusHistoryModal={openStatusHistoryModal}
                handleCloseModal={handleCloseStatusHistoryModal}
                loading={loading}
                columnsStatusHistory={columnsStatusHistory}
                total={total}
                rows={rows}
            />
        </>
    );
};
